"use strict";


import { MarketGlobalInfo } from 'api/ordersAPICall';
import { objectMap }  from  'generics/utils';


LogStream.enable( "GLOBALMARKETCONFIGSTORAGE" );


class GlobalMarketConfigStorage  {
  constructor()  {
    this.marketFee = 0;
    this.games = {};
    this.ready = false;
    this.priceMin = 0;
    this.priceMax = 0;
  }


  load()  {
    return MarketGlobalInfo().then( ( resp ) =>  {
        this.marketFee = resp.marketFee || 0;
        this.priceMin = resp.minPrice || 1000;
        this.priceMax = resp.maxPrice || 2000000000;

        this.games = {};
        objectMap( resp.games, ( game ) =>  {
            if ( game.appid < 1 )
              return;
            if ( !game.briefName || !game.name )
              return;
            if ( !game.icon || !game.banner )
              return;
            if ( !game.desc || !game.desc.length )
              return;

            this.games[ game.appid ] = game;
          });

        this.ready = true;
        LogStream("GLOBALMARKETCONFIGSTORAGE").info( "load (", this, ")" );
        return resp;
      });
  }


  check()  {
    if ( !this.ready )
      throw new Error( "GlobalMarketConfigStorage was not loaded properly ");
  }


  unresolvedApp( appid )  {
    return {
        "appid"         : appid,
        "briefName"     : "N/A",
        "name"          : "N/A",
        "desc"          : [ "N/A" ],
        "icon"          : "images/loader.gif",
        "banner"        : "images/loader.gif",
        "unresolved"    : true
      };
  }

  resolveAppId( appid )  {
    this.check();
    return this.games[appid] || this.unresolvedApp( appid );
  }


  getAppIdList()  {
    this.check();
    return Object.keys(this.games);
  }


  getMarketFee()  {
    this.check();
    return this.marketFee || 0;
  }

  getPriceMin()  {
    this.check();
    return this.priceMin;
  }

  getPriceMax()  {
    this.check();
    return this.priceMax;
  }
};


let G_marketConfigStorage = new GlobalMarketConfigStorage(); // FIXME, should be separate component
export default G_marketConfigStorage;
